import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import ZoomInIcon from 'material-ui/svg-icons/action/zoom-in';
import Popover from 'material-ui/Popover/Popover';
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import Restore from 'material-ui/svg-icons/av/replay';
import Checkbox from 'material-ui/Checkbox';
import * as Colors from 'material-ui/styles/colors';
import {getResizeUrl} from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';
import sassStyles from './AssetsImage.scss';
import ChildrenFader from 'shared/components/ChildrenFader';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import ImageDropDownMenu from '../ImageDropDownMenu';
import Img from 'shared/components/Img/Img';

export const SELECTION_TYPES = {
  REGULAR_SELECTION: 0,
  CTRL_SELECTION: 1,
  SHIFT_SELECTION: 2,
  CTRL_AND_SHIFT_SELECTION: 3,
};

const imageSizeMax = 200;
const imageZoomSize = imageSizeMax * 2;

const styles = {
  imageButton: {
    width: 36,
    height: 36,
    padding: 5,
    zIndex: 3,
  },
  imageButtonIcon: {
    color: '#fff',
  },
  itemInner: {
    padding: '0px 16px 0px 50px',
  },
  checkbox: {
    width: 24,
    position: 'absolute',
    top: 0,
    left: 0,
  },
  checkboxBackground: {
    position: 'absolute',
    width: 16,
    height: 16,
    overflow: 'hidden',
    borderRadius: '2px',
    top: 4,
    left: 4,
  },
  zoomImage: {
    boxSizing: 'content-box',
    border: '10px solid white',
  },
  imageBorder: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 2,
    boxSizing: 'border-box',
  },
};

export default class AssetsImage extends PureComponent {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      zoomOn: false,
      openImageDropDownMenu: false,
    };
  }

  getUrlLastModified(url, width) {
    return getResizeUrl(url + `?modified=${this.props.item.date}`, {width});
  }

  toggleIconMenu = open => {
    this.setState({open});
  };

  zoomOnDelay;

  zoomOn = event => {
    event.preventDefault();
    this.zoomOnDelay = setTimeout(() => {
      this.setState({
        anchorElZoom: this.refs.imageButtons,
        zoomOn: true,
      });
    }, 150);
  };

  zoomOff = () => {
    clearTimeout(this.zoomOnDelay);
    this.setState({zoomOn: false});
  };

  _handleEnterBox = () => {
    this.setState({boxHover: true});
  };

  _handleLeaveBox = () => {
    this.setState({boxHover: false});
  };

  handleLoad = event => {
    this.image = event.target;
  };

  handleSelection = (ctrlKeyPressed, shiftKeyPressed) => {
    const {item, onSelect} = this.props;
    if (_.isFunction(onSelect)) {
      switch (true) {
        case ctrlKeyPressed && shiftKeyPressed:
          onSelect(item, SELECTION_TYPES.CTRL_AND_SHIFT_SELECTION);
          break;
        case ctrlKeyPressed:
          onSelect(item, SELECTION_TYPES.CTRL_SELECTION);
          break;
        case shiftKeyPressed:
          onSelect(item, SELECTION_TYPES.SHIFT_SELECTION);
          break;
        default:
          onSelect(item, SELECTION_TYPES.REGULAR_SELECTION);
      }
    }
  };

  toggleImageDropDownMenu = value => {
    this.setState({openImageDropDownMenu: value});
  };

  renderButtons(urlZoom) {
    const {
      item,
      item: {url, name},
      resourceType,
      currentFolder,
      innerkey,
      integrated,
      onRestoreFromTrashButtonClick,
      onCropAndEditButtonClick,
      imageDropDownFunctions,
      onDeleteButtonClick,
      id,
    } = this.props;
    const {zoomOn, anchorElZoom} = this.state;
    const tooltipPosition = 'top-center';
    const image = this.image;
    let sizes = {};
    if (image) {
      if (image.naturalHeight - image.naturalWidth < 0) {
        sizes = {
          width: imageZoomSize,
          height: (imageZoomSize * image.naturalHeight) / image.naturalWidth,
        };
      } else {
        sizes = {
          height: imageZoomSize,
          width: (imageZoomSize * image.naturalWidth) / image.naturalHeight,
        };
      }
    }
    return (
      <div className={sassStyles.buttonBlock} onClick={e => e.stopPropagation()} ref="imageButtons">
        <div>
          <IconButton
            className="cla-image-zoom"
            style={styles.imageButton}
            iconStyle={styles.imageButtonIcon}
            onMouseEnter={this.zoomOn}
            onMouseLeave={this.zoomOff}
            tooltip="Zoom"
            tooltipPosition={tooltipPosition}
          >
            <ZoomInIcon />
          </IconButton>
          {_.isFunction(onRestoreFromTrashButtonClick) && (
            <IconButton
              className="cla-image-restore"
              style={styles.imageButton}
              iconStyle={styles.imageButtonIcon}
              tooltip="Restore from Trash"
              tooltipPosition={tooltipPosition}
              onClick={() => onRestoreFromTrashButtonClick(item)}
            >
              <Restore />
            </IconButton>
          )}
        </div>
        <div>
          {_.isFunction(onCropAndEditButtonClick) && (
            <IconButton
              style={styles.imageButton}
              iconStyle={styles.imageButtonIcon}
              tooltip="Crop & Edit"
              tooltipPosition={tooltipPosition}
              onClick={() => onCropAndEditButtonClick(item)}
            >
              <CreateIcon />
            </IconButton>
          )}
          {imageDropDownFunctions ? (
            // TODO make ImageDropDownMenu a presentational component
            <ImageDropDownMenu
              item={item}
              tooltipPosition={tooltipPosition}
              currentFolder={currentFolder}
              resourceType={resourceType}
              innerkey={innerkey}
              integrated={integrated}
              toggleImageDropDownMenu={this.toggleImageDropDownMenu}
              iconColor="#fff"
            />
          ) : (
            <IconButton
              className="cla-image-restore"
              style={styles.imageButton}
              iconStyle={styles.imageButtonIcon}
              tooltip="Delete"
              tooltipPosition={tooltipPosition}
              onClick={() => onDeleteButtonClick(item)}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
        <Popover open={zoomOn} anchorEl={anchorElZoom} useLayerForClickAway={false}>
          <Img className="cla-zoomed-img" src={urlZoom} style={{...styles.zoomImage, ...sizes}} alt={name} />
        </Popover>
      </div>
    );
  }

  render() {
    const {item, selected, imageSize, showCheckbox, style, id} = this.props;
    const {boxHover, openImageDropDownMenu} = this.state;
    const url = this.getUrlLastModified(item.url, imageSizeMax * 2);
    let checkboxColor;
    let checkboxBackground;
    let selectedBorder;
    if (selected) {
      checkboxColor = Colors.lightGreen800;
      checkboxBackground = 'white';
      selectedBorder = `2px solid ${Colors.lightGreen600}`;
    } else {
      checkboxColor = Colors.grey500;
      checkboxBackground = Colors.grey300;
      selectedBorder = 'none';
    }

    return (
      <Paper
        id={id}
        style={{...style, width: imageSize, height: imageSize}}
        zDepth={1}
        rounded={false}
        onClick={e => e.stopPropagation()}
        onMouseEnter={this._handleEnterBox}
        onMouseLeave={this._handleLeaveBox}
      >
        <TooltipWrapper
          tooltip={item.name}
          enterDelay={1000}
          popoverType="grey"
          anchorOrigin={{horizontal: 'left', vertical: 'top'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          tooltipStyle={{
            maxWidth: 'auto',
            padding: '0 8px',
            fontSize: '10px',
            lineHeight: '22px',
          }}
          showOnlyOnMouseNotMove
          popoverStyle={{
            marginTop: 10,
            marginLeft: 35,
          }}
          style={{position: 'relative', maxHeight: '100%', height: '100%'}}
        >
          <div
            style={{width: '100%', height: '100%'}}
            className={`${sassStyles.imageBox} ${sassStyles.downloadBlock}`}
            onClick={event => this.handleSelection(event.ctrlKey, event.shiftKey)}
          >
            <Img
              className="cla-img"
              onLoad={this.handleLoad}
              src={url}
              alt={item.name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: Colors.white,
              }}
              ref="image"
            />
            <div className="cla-image-select" style={{...styles.imageBorder, border: selectedBorder}} />
            <ChildrenFader visible={boxHover || openImageDropDownMenu} transitionDurationMs={0}>
              {(boxHover || openImageDropDownMenu) && this.renderButtons(url)}
            </ChildrenFader>
          </div>
          {showCheckbox && (
            <ChildrenFader visible={boxHover || selected} transitionDurationMs={0}>
              {(boxHover || selected) && (
                <div className={sassStyles.imageButtonsTop} style={{position: 'absolute', top: 4, left: 4}}>
                  <div style={{...styles.checkboxBackground, background: checkboxBackground}} />
                  <Checkbox
                    className="cla-image-checkbox"
                    checked={selected}
                    iconStyle={{fill: checkboxColor, left: 0, margin: 0}}
                    style={styles.checkbox}
                    onClick={event => this.handleSelection(true, event.shiftKey)}
                  />
                </div>
              )}
            </ChildrenFader>
          )}
        </TooltipWrapper>
      </Paper>
    );
  }
}

AssetsImage.propTypes = {
  item: PropTypes.object,
  selected: PropTypes.bool,
  imageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showCheckbox: PropTypes.bool,
  onSelect: PropTypes.func,
  onRestoreFromTrashButtonClick: PropTypes.func,
  onCropAndEditButtonClick: PropTypes.func,
  /**
   * imageDropDownFunctions - pass this prop to display the menu button at the rightmost part of the image.
   * When the imageDropDownMenu is transformed into a presentational component you should pass the
   * functions you wish to enable through this array.
   * Not passing this prop will display the delete button at the rightmost part of the image.
   **/
  imageDropDownFunctions: PropTypes.object,
  /**
   * onDeleteButtonClick - This function will be called when the delete button is pressed.
   * The delete button is shown only if the imageDropDownFunctions prop is not passed.
   */
  onDeleteButtonClick: PropTypes.func,
};
